const Footer = () => {
    return (
        <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4">
                {/* Logo and Title */}
                <div className="text-center mb-12">
                    <div className="inline-flex items-center space-x-3 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-pink-500 rounded-full flex items-center justify-center">
                            <span className="text-white font-bold text-2xl">WC</span>
                        </div>
                        <div>
                            <h2 className="text-3xl font-bold">WOODLANDS CONFERENCE</h2>
                            <p className="text-cyan-300 font-semibold">ADVENTIST YOUTH MINISTRIES</p>
                        </div>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-12 mb-12">
                    {/* Social Media */}
                    <div>
                        <h3 className="text-xl font-bold mb-6 relative inline-block">
                            <span className="relative z-10">WC Socials</span>
                            <div className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-pink-500 rounded-full"></div>
                        </h3>
                        <p className="text-gray-300 mb-6">Connect with us on social media for updates and inspiration.</p>
                        <div className="flex space-x-4">
                            {[
                                { icon: 'facebook', color: 'from-blue-600 to-blue-800' },
                                { icon: 'twitter', color: 'from-cyan-500 to-blue-600' },
                                { icon: 'instagram', color: 'from-pink-500 to-purple-600' },
                                { icon: 'whatsapp', color: 'from-green-500 to-emerald-600' }
                            ].map((social, idx) => (
                                <a
                                    key={idx}
                                    href="#"
                                    className={`w-12 h-12 rounded-xl bg-gradient-to-r ${social.color} flex items-center justify-center transform hover:scale-110 hover:shadow-2xl transition-all duration-300`}
                                >
                                    <i className={`fab fa-${social.icon} text-white text-xl`}></i>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-6 relative inline-block">
                            <span className="relative z-10">CONTACT</span>
                            <div className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full"></div>
                        </h3>
                        <div className="space-y-4">
                            <div className="flex items-start space-x-3">
                                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                    <i className="fas fa-home text-white"></i>
                                </div>
                                <p className="text-gray-300">Lusaka, Woodlands, Zambia</p>
                            </div>
                            <div className="flex items-start space-x-3">
                                <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                    <i className="fas fa-envelope text-white"></i>
                                </div>
                                <p className="text-gray-300">email@wcay.com</p>
                            </div>
                            <div className="flex items-start space-x-3">
                                <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-green-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                    <i className="fas fa-phone text-white"></i>
                                </div>
                                <p className="text-gray-300">+260 966749476</p>
                            </div>
                        </div>
                    </div>

                    {/* Important Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-6 relative inline-block">
                            <span className="relative z-10">Important Links</span>
                            <div className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full"></div>
                        </h3>
                        <div className="space-y-4">
                            {[
                                { name: 'GC AY', link: 'GC AY facebook' },
                                { name: 'SID AY', link: 'SID AY facebook' },
                                { name: 'SZBU AY', link: 'SZBU AY facebook' },
                                { name: 'Woodlands Conference AY', link: 'Woodlands Conference AY facebook' }
                            ].map((link, idx) => (
                                <div key={idx} className="group">
                                    <div className="flex items-center space-x-2 mb-1">
                                        <div className="w-2 h-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full group-hover:scale-125 transition-transform duration-300"></div>
                                        <span className="font-semibold group-hover:text-cyan-300 transition-colors duration-300">{link.name}</span>
                                    </div>
                                    <a href="#" className="text-gray-400 text-sm group-hover:text-white transition-colors duration-300 block ml-4">
                                        {link.link}
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="pt-8 border-t border-gray-700">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-400 mb-4 md:mb-0">
                            © 2024 Copyright: <a href="#" className="text-cyan-300 hover:text-white transition-colors duration-300 font-semibold"> Woodlands Conference AY Ministry </a>
                        </p>
                        <div className="flex items-center space-x-2">
                            <div className="text-sm text-gray-400">Powered by</div>
                            <div className="px-3 py-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full text-white font-bold">
                                AY Digital
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;